import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  documentId,
} from "firebase/firestore";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { InputMask } from "primereact/inputmask";
import { formatPhoneNumber } from "../functions/formatFunctions";
import WomanProfile from "../images/Woman-Profile.png";

const EditUserProfile = ({ user }) => {
  const [userData, setUserData] = useState(null);
  const [documentId, setdocumentId] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    website: "",
    instagram: "",
    facebook: "",
    bio: "",
  });

  const navigate = useNavigate();

  function formatPhoneNumber(input) {
    // Remove any non-numeric characters
    const cleanedValue = input.value.replace(/\D/g, "");

    // Format the phone number as "xxx-xxx-xxxx"
    let formattedValue = "";
    for (let i = 0; i < cleanedValue.length; i++) {
      if (i === 3 || i === 6) {
        formattedValue += "-";
      }
      formattedValue += cleanedValue.charAt(i);
    }

    // Update the input value with the formatted phone number
    input.value = formattedValue;
  }

  useEffect(() => {
    if (user) {
      // Use onAuthStateChanged to listen for changes in the authentication state
      const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
        if (authUser) {
          const userUid = authUser.uid;
          const artistsCollectionRef = collection(db, "artists");
          const q = query(
            artistsCollectionRef,
            where("authRegID", "==", userUid)
          );

          try {
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              const userData = querySnapshot.docs[0].data();
              const documentId = querySnapshot.docs[0].id;
              console.log("The document ID is", documentId);
              setdocumentId(documentId);
              setUserData(userData);
              setFormData({
                first_name: userData.first_name,
                last_name: userData.last_name,
                email: userData.email,
                phone: userData.phone,
                website: userData.website,
                instagram: userData.instagram,
                facebook: userData.facebook,
                bio: userData.bio,
              });
            } else {
              setUserData(null);
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
            setUserData(null);
          }
        } else {
          setUserData(null);
        }
      });

      return () => unsubscribe();
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Perform validation if needed

    try {
      console.log("from ln 91 user.uid", user.uid);
      // Update the user's data in Firestore
      const artistDocRef = doc(db, "artists", documentId);
      // Replace "id" with the actual field name

      await updateDoc(artistDocRef, {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        website: formData.website,
        instagram: formData.instagram,
        facebook: formData.facebook,
        bio: formData.bio,
      });

      // Redirect or display a success message
      navigate("/UserProfile"); // Replace with the actual path to view the updated profile
    } catch (error) {
      console.error("Error updating user data:", error);
    }
  };

  return (
    <Container className='mt-4'>
      <Row>
        <Col lg={12}>
          <h1 className='whiteText'>Edit Profile</h1>
        </Col>
        <Col lg={6} className='whiteText mt-4'>
          <Form onSubmit={handleSubmit}>
            {/* Include form fields for editing user data */}
            <Form.Group controlId='first_name'>
              <Row>
                <Col>
                  <Form.Label> First Name</Form.Label>
                  <Form.Control
                    type='text'
                    name='first_name'
                    value={`\u{1F512} ${formData.first_name}`}
                    readOnly
                    className='custom-read-only'
                  />
                </Col>
                <Col>
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type='text'
                    name='last_name'
                    value={`\u{1F512} ${formData.last_name}`}
                    readOnly
                    className='custom-read-only'
                  />{" "}
                </Col>
                <Col>
                  <Form.Label>&#x1F512; Email</Form.Label>
                  <Form.Control
                    type='text'
                    name='email'
                    value={`\u{1F512}${formData.email}`}
                    readOnly
                    className='custom-read-only'
                  />
                </Col>{" "}
              </Row>{" "}
              <Row>
                <Col>
                  <Form.Label>Phone</Form.Label>
                  <InputMask
                    type='text' // Use type 'text' for phone number input
                    name='phone'
                    className='form-control'
                    value={formData.phone}
                    onChange={handleChange}
                    mask='999-999-9999'
                    placeholder='999-999-9999'
                  />
                  {/* <Form.Control
                    type='text' // Use type 'text' for phone number input
                    name='phone'
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder='Enter phone number (e.g., 999-999-9999)'
                  /> */}
                </Col>
                <Col>
                  <Form.Label>Website</Form.Label>
                  <Form.Control
                    type='text'
                    name='website'
                    value={formData.website}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label>Instagram</Form.Label>
                  <Form.Control
                    type='text'
                    name='instagram'
                    value={formData.instagram}
                    onChange={handleChange}
                  />
                </Col>
                <Col>
                  <Form.Label>Facebook</Form.Label>
                  <Form.Control
                    type='text'
                    name='facebook'
                    value={formData.facebook}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <Form.Label>Bio</Form.Label>
              <Form.Control
                as='textarea'
                name='bio'
                value={formData.bio}
                onChange={handleChange}
                rows={10}
                style={{ width: "100%" }} // Set the width to 100%
                maxLength={1800}
              />
            </Form.Group>

            {/* Add more form fields for other data (last_name, email, etc.) */}

            <Button variant='primary' type='submit'>
              Save Changes
            </Button>
          </Form>
        </Col>
        <Col lg={6} className='text-center mt-5'>
          <img src={WomanProfile} alt='Artist Showcase' className='img-fluid' />
        </Col>
      </Row>
    </Container>
  );
};

export default EditUserProfile;
